import React, { createContext } from 'react'
import { useQuery } from '@apollo/client'
import useMe from 'src/graphql/hooks/useMe'
import { getMyUnreadMessageCount as getMyUnreadMessageCountGql }
   from 'src/graphql/queries/getMyUnreadMessageCount.gql'
import PropTypes from 'prop-types'

export const MyNotificationCountContext = createContext()

const MyNotificationCountProvider = ({ children }) => {
   const { me, isLoggedIn } = useMe()
   const { data, refetch } = useQuery(getMyUnreadMessageCountGql, {
      errorPolicy: 'ignore',
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      // Poll every 30 seconds
      pollInterval: process.env.NODE_ENV !== 'test'
         ? 30000
         : undefined,
      skip: !isLoggedIn,
      variables: {
         userRelationshipFilter: {
            userId: 'me',
            hasUnreadMessages: true
         }
      }
   })

   // eslint-disable-next-line max-len
   const notificationCount = (me?.invitations?.length ?? 0) + (data?.initiativeList?.items.length ?? 0)
   let notificationCountResult = null

   // If there's a next "page", then we append a "+" to the number
   if (data?.initiativeList?.listInfo.hasNext) {
      notificationCountResult = `${notificationCount}+`
   } else if (notificationCount > 0) {
      notificationCountResult = notificationCount.toString()
   }

   const contextValue = {
      refetch,
      notificationCount: notificationCountResult
   }

   return (
      <MyNotificationCountContext.Provider value={contextValue}>
         {children}
      </MyNotificationCountContext.Provider>
   )
}

MyNotificationCountProvider.propTypes = {
   children: PropTypes.node.isRequired
}

export { MyNotificationCountProvider }
